import { Outlet } from 'react-router-dom';
import { MobileBottomNav } from './NavPlan';
import { BackBar, HistoryGuards } from './BackBar';
import { useResponsiveTables } from '@/hooks/useResponsiveTables';

// Coque employé : barre basse mobile (Pointer · Planning · Documents · Profil) + zone sûre iPhone
export default function EmployeeShell() {
  useResponsiveTables('[data-testid="employee-shell"]');
  return (
    <div className="min-h-screen pb-[calc(64px+env(safe-area-inset-bottom))] lg:pb-0" data-testid="employee-shell">
      <HistoryGuards />
      <div className="px-4 pt-3 lg:hidden"><BackBar items={[]} role="employee" /></div>
      <Outlet />
      <MobileBottomNav role="employee" />
    </div>
  );
}
